export default __webpack_public_path__ + "static/media/intro3.1517f1f5.mp3";